import { Injectable } from '@angular/core';

import { CustomerAddress } from '../../../customer/model/customer-information.model';
import { normalizeProvinceCode } from '../../../utils/province-code';
import { TolerantPostResponseModel, TolerantPostResult } from '../model/response.model';
import { SuggestedAddress, SuggestedAddresses } from '../model/view.model';

@Injectable({
  providedIn: 'root',
})
export class TolerantPostViewModelMapper {
  mapResponse(responseModel: TolerantPostResponseModel | null): SuggestedAddresses {
    return responseModel?.results.map((result) => this.mapResult(result)) ?? [];
  }

  private mapResult(result: TolerantPostResult): SuggestedAddress {
    return {
      street: this.mapString(result.street),
      dependantstreet: this.mapString(result.dependantstreet),
      houseNumber: this.mapString(result.HouseNumber),
      addressLine2: this.mapString(result.addressline2),
      addressLine3: this.mapString(result.addressline3),
      postalCode: this.mapString(result.postalcode),
      city: this.mapString(result.city),
      province: this.mapString(result.province),
      country: this.mapString(result.country),
      countryCode: this.mapString(result.countrycode),
      provinceCode: this.mapString(result.provincecode),
      score: this.mapString(result.score),
      quality: this.mapString(result.quality),
      building: this.mapString(result.building),
      subbuilding: this.mapString(result.subbuilding),
      postSingleLine: this.mapString(result.post_singleline),
      pobox: this.mapString(result.pobox),
    };
  }

  mapToCustomerAddress(suggestedAddress?: SuggestedAddress): CustomerAddress {
    return {
      postalCode: suggestedAddress?.postalCode ?? '',
      city: suggestedAddress?.city ?? '',
      houseNumber: suggestedAddress?.houseNumber ?? '',
      street: [suggestedAddress?.dependantstreet, suggestedAddress?.street].filter(Boolean).join(', '),
      province: normalizeProvinceCode(
        suggestedAddress?.provinceCode, // "BY", not the full name
        suggestedAddress?.countryCode, // "DE"
      ),
      country: suggestedAddress?.countryCode,
      addressLine1: [suggestedAddress?.subbuilding, suggestedAddress?.building].filter(Boolean).join(', '),
      addressLine2: suggestedAddress?.addressLine3 ?? '',
      // "" rather than undefined, so the PUT carries it and clears a stored PO box (CUSTAPP-814).
      postBox: suggestedAddress?.pobox ?? '',
    };
  }

  private mapString(value: string): string | undefined {
    return value && value.trim() !== '' ? value : undefined;
  }
}
